import React from 'react'
import ThemeControl from '../../../Components/ui/ThemeControl '

export default function Settings() {
  return (
    <div className='flex-1 h-screen overflow-x-auto bg-[#f5f5f5]'>
      <ThemeControl />
    </div>
  )
}
